<template>
  <div class="waybill-form-page">
    <div class="page-heading">
      <div><div class="page-heading__title">{{ isEdit ? '编辑运单' : '新增运单' }}</div><div class="page-heading__sub">填写运输节点，按需规划线路并创建在途监控任务</div></div>
      <div class="page-heading__actions"><el-button icon="el-icon-map-location" v-permission="['waybill:monitor', 'fullmap:view']" :disabled="saving" @click="openWaybillMap">查看运单地图</el-button><el-button icon="el-icon-back" :disabled="saving" @click="backToList">返回列表</el-button></div>
    </div>
    <el-form v-loading="saving" :disabled="saving" ref="form" :model="form" :rules="rules" label-width="110px" class="waybill-form">
      <section class="form-section node-section">
        <div class="section-title">线路信息</div>
        <div class="section-fields">
        <el-form-item label="规划线路" class="planning-row">
          <el-switch v-model="planningEnabled" />
          <template v-if="planningEnabled">
            <el-select v-model="routeFillId" clearable filterable :loading="routeLoading" placeholder="从已有线路填充（可选）" @change="applyRouteTemplate" @visible-change="$event && loadRoutes()"><el-option v-for="route in routes" :key="route.id" :label="routeOptionLabel(route)" :value="route.id" /></el-select>
            <el-button v-permission="'route:list'" type="text" icon="el-icon-setting" @click="openRouteManage">线路管理</el-button>
          </template>
        </el-form-item>
        <div v-for="item in transportNodes" :key="item.key" class="transport-node">
          <div class="node-main-row">
            <el-form-item :label="item.title" required class="node-address-item">
              <template slot="label"><span class="node-address-label"><span>{{ item.title }}</span><el-tooltip content="围栏范围、联系人、联系人电话" placement="top"><el-button type="text" class="node-details-toggle" :aria-label="item.node.detailsExpanded ? '收起补充信息' : '展开补充信息'" :aria-expanded="!!item.node.detailsExpanded" @click.stop="$set(item.node, 'detailsExpanded', !item.node.detailsExpanded)">补充信息<i :class="item.node.detailsExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" aria-hidden="true" /></el-button></el-tooltip></span></template>
              <div class="node-address-fields"><waybill-location-input v-model="item.node.address" :location-context="item.node" @unlocated="onNodeAddressInput(item.node)" @confirm="applyNodeLocation(item.node, $event)"><address-book-input slot="append" button-mode class="node-address-book" @select="applyAddressBook(item.node, $event)" @create="openAddressBookCreate(item.node)" /></waybill-location-input><el-button plain icon="el-icon-map-location" @click="openLocationPicker(item.node)">选点</el-button></div>
            </el-form-item>
            <el-form-item :label="item.type === 'origin' ? '计划出发时间' : item.type === 'target' ? '计划结束时间' : '计划到达时间'" :prop="item.type === 'origin' ? 'planStartTime' : item.type === 'target' ? 'planArriveTime' : null" class="node-time-item">
              <el-date-picker v-if="item.type === 'origin'" v-model="form.planStartTime" type="datetime" value-format="timestamp" placeholder="请选择时间" />
              <el-date-picker v-else-if="item.type === 'target'" v-model="form.planArriveTime" type="datetime" value-format="timestamp" placeholder="请选择时间" />
              <el-date-picker v-else v-model="item.node.planArriveTime" type="datetime" value-format="timestamp" placeholder="选填" />
            </el-form-item>
            <div v-if="item.type === 'stopover'" class="node-operations"><el-button type="text" :disabled="item.index === 0" @click="moveStopover(item.index, -1)">上移</el-button><el-button type="text" :disabled="item.index === form.transportStopovers.length - 1" @click="moveStopover(item.index, 1)">下移</el-button><el-button type="text" class="danger-button" @click="removeStopover(item.index)">移除</el-button></div>
          </div>
          <div v-if="item.node.detailsExpanded" class="node-details">
            <el-form-item label="联系人"><el-input v-model.trim="item.node.contactName" maxlength="64" /></el-form-item>
            <el-form-item label="联系电话"><el-input v-model.trim="item.node.contactPhone" maxlength="20" /></el-form-item>
            <el-form-item label="围栏半径"><el-input-number v-model="item.node.radius" :min="50" :max="5000" :step="50" controls-position="right" /></el-form-item>
            <el-form-item label="坐标"><coordinate-input :value="item.node.lonLat" readonly placeholder="选点后自动显示" /></el-form-item>
          </div>
        </div>
        <div class="node-extra-actions"><el-button type="text" icon="el-icon-plus" :disabled="form.transportStopovers.length >= 8" @click="addStopover">添加经停点</el-button><span>最多 8 个经停点</span></div>
        <el-form-item v-if="planningEnabled" label="线路规划" class="plan-summary-row"><el-button type="primary" plain icon="el-icon-guide" :loading="routeDetailLoading" @click="openRoutePlanner">{{ selectedRoute ? '查看 / 调整线路' : '规划路线' }}</el-button><span v-if="selectedRoute" class="route-selected">{{ selectedRoute.routeName }} · {{ Number(selectedRoute.totalDileage).toFixed(2) }} 公里 · {{ routeDurationText(selectedRoute.totalDuration) }}</span><span v-else class="route-template-tip">待重新规划</span></el-form-item>
        </div>
      </section>
      <section class="form-section">
        <div class="section-title">车辆司机</div>
        <div class="section-fields">
        <div class="form-grid vehicle-form-grid">
          <el-form-item label="车牌号" required><div class="inline-fields"><vehicle-tree-picker ref="vehiclePicker" :disabled="saving" v-model="form.vno" :vehicle-id="form.vehicleId" @manual-input="onVehicleManualInput" @select="onVehicleSelect" @manage="openVehicleManage" /><el-button v-permission="'vehicle:add'" plain type="primary" icon="el-icon-plus" @click="vehicleCreateVisible = true">新增</el-button></div></el-form-item>
          <el-form-item label="司机"><div class="inline-fields driver-picker"><el-select v-model="selectedDriverId" clearable filterable placeholder="请选择司机" @change="onDriverChange"><el-option v-for="driver in driverOptions" :key="driver.id" :label="`${driver.driverName}（${driver.phone}）`" :value="driver.id" :disabled="driver.disabled" /></el-select><el-button v-permission="'driver:add'" plain type="primary" icon="el-icon-plus" @click="driverDrawerVisible = true">新增</el-button></div></el-form-item>
          <el-form-item label="司机电话"><el-input v-model.trim="form.driverPhone" maxlength="20" /></el-form-item>
        </div>
        </div>
      </section>
      <section class="form-section">
        <div class="section-title">运单信息</div>
        <div class="section-fields">
        <div class="form-grid">
          <el-form-item label="运单号" prop="transportNo"><el-input v-model.trim="form.transportNo" maxlength="50" :disabled="isEdit" placeholder="输入或生成运单号"><el-button slot="append" :disabled="isEdit" @click="generateTransportNo">生成</el-button></el-input></el-form-item>
          <el-form-item label="货物名称"><el-input v-model.trim="form.goodsName" maxlength="100" placeholder="请输入货物名称" /></el-form-item>
        </div>
        <el-form-item label="途中围栏">
          <div class="fence-actions">
            <el-popover v-model="fencePickerVisible" placement="bottom-start" :width="480" trigger="click" :disabled="saving" @show="loadFences">
              <div class="fence-picker-panel">
                <div class="fence-picker-panel__toolbar"><el-input v-model.trim="fenceKeyword" clearable size="small" prefix-icon="el-icon-search" placeholder="搜索围栏名称或编码" /><el-button size="small" icon="el-icon-refresh" :loading="fenceLoading" @click="loadFences">刷新</el-button></div>
                <div v-loading="fenceLoading" class="fence-picker-panel__list">
                  <el-checkbox-group v-model="form.waypointFenceCodes" :disabled="saving"><el-checkbox v-for="fence in fencePickerOptions" :key="fence.fenceCode" :label="fence.fenceCode">{{ fence.fenceName }}（{{ fence.fenceCode }}）</el-checkbox></el-checkbox-group>
                  <div v-if="!fencePickerOptions.length && !fenceLoading" class="route-template-tip">暂无匹配围栏</div>
                </div>
              </div>
              <el-input slot="reference" class="fence-picker" readonly :value="selectedFences.length ? `已选择 ${selectedFences.length} 个围栏` : ''" placeholder="选择已有运单围栏" :suffix-icon="fencePickerVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" :aria-expanded="fencePickerVisible" />
            </el-popover>
            <el-button v-permission="'fence:add'" plain type="primary" icon="el-icon-plus" @click="openFenceCreate">新增围栏</el-button>
          </div>
          <el-table v-if="selectedFences.length" :data="selectedFences" row-key="fenceCode" border size="small" class="fence-node-table">
            <el-table-column prop="fenceCode" label="围栏编码" min-width="140" show-overflow-tooltip />
            <el-table-column prop="fenceName" label="围栏名称" min-width="130" show-overflow-tooltip />
            <el-table-column label="围栏类型" width="90"><template slot-scope="{ row }">{{ fenceTypeText(row.fenceType) }}</template></el-table-column>
            <el-table-column label="监控事件" min-width="105"><template slot-scope="{ row }">{{ eventTypeText(row.eventType) }}</template></el-table-column>
            <el-table-column label="坐标" min-width="160" show-overflow-tooltip><template slot-scope="{ row }">{{ fenceCoordinateText(row.fenceCoords) }}</template></el-table-column>
            <el-table-column label="半径" width="65"><template slot-scope="{ row }">{{ Number(row.fenceType) === 1 ? `${row.fenceRadius || '-'} 米` : '-' }}</template></el-table-column>
            <el-table-column label="操作" fixed="right" width="100"><template slot-scope="{ row }"><div class="fence-table-actions"><el-button type="text" @click="viewFence(row)">查看</el-button><el-button type="text" class="danger-button" @click="removeFence(row.fenceCode)">移除</el-button></div></template></el-table-column>
          </el-table>
          <div v-else class="fence-empty route-template-tip">暂未关联途中围栏</div>
        </el-form-item>
        <el-form-item label="备注" class="remark-row"><el-input v-model.trim="form.remark" maxlength="256" placeholder="请输入备注" /></el-form-item>
        </div>
      </section>
    </el-form>
    <div class="form-actions"><el-button :disabled="saving" @click="backToList">取消</el-button><el-button type="primary" :loading="saving" v-permission="isEdit ? 'waybill:edit' : 'waybill:add'" @click="submit">保存运单</el-button></div>
    <div v-for="session in [formSession]" :key="session">
    <waybill-location-picker :visible="locationPickerVisible" @update:visible="updateDialogVisibility('locationPickerVisible', $event, session)" :lon-lat="selectedNode ? selectedNode.lonLat : ''" :address="selectedNode ? selectedNode.address : ''" :area-codes="selectedNode ? selectedNode.areaCodes : []" :area-name="selectedNode ? getAreaName(selectedNode) : ''" @confirm="applyPickedLocation($event, session)" />
    <address-book-drawer :visible="addressBookDrawerVisible" @update:visible="updateDialogVisibility('addressBookDrawerVisible', $event, session)" :address-book="addressBookToCreate" @saved="onAddressBookSaved($event, session)" />
    <driver-form-drawer :visible="driverDrawerVisible" @update:visible="updateDialogVisibility('driverDrawerVisible', $event, session)" @saved="onDriverSaved($event, session)" />
    <vehicle-form-dialog :visible="vehicleCreateVisible" @update:visible="updateDialogVisibility('vehicleCreateVisible', $event, session)" :vehicle="{}" @saved="onVehicleSaved($event, session)" />
    <waybill-route-dialog :visible="routeDialogVisible" @update:visible="updateDialogVisibility('routeDialogVisible', $event, session)" :initial-waybill="mapWaybill" :initial-stopovers="mapStopovers" :initial-route="selectedRoute" :source-route="sourceRoute" @saved="(route, plan) => onRouteSaved(route, plan, session)" @cancel="onRouteCancelled(session)" />
    <waybill-fence-dialog :visible="fenceDialogVisible" @update:visible="updateDialogVisibility('fenceDialogVisible', $event, session)" :saving="fenceSaving" :readonly="fenceReadonly" :fence="fenceToView" @submit="onSubmitFence($event, session)" />
    <waybill-map-dialog :visible="mapDialogVisible" @update:visible="updateDialogVisibility('mapDialogVisible', $event, session)" :draft-mode="!isEdit" :waybill="mapWaybill" :stopovers="mapStopovers" :fences="selectedFences" :initial-route-plan="planningEnabled ? selectedRoute : null" />
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { regionData } from 'element-china-area-data'
import { createWaybill, getAvailableRoutes, getDriverList, getFenceList, getRouteDetail, getWaybillDetail, isRequestSuccess, saveFence, updateWaybill } from './lingdongApi'
import WaybillLocationPicker from './WaybillLocationPicker.vue'
import CoordinateInput from './CoordinateInput.vue'
import DriverFormDrawer from './DriverFormDrawer.vue'
import VehicleTreePicker from './VehicleTreePicker.vue'
import VehicleFormDialog from './VehicleFormDialog.vue'
import WaybillLocationInput from './WaybillLocationInput.vue'
import WaybillRouteDialog from './WaybillRouteDialog.vue'
import WaybillFenceDialog from './WaybillFenceDialog.vue'
import WaybillMapDialog from './WaybillMapDialog.vue'
import AddressBookInput from './AddressBookInput.vue'
import AddressBookDrawer from './AddressBookDrawer.vue'
import { setAmapSecurityConfig, loadAmapSDK } from '@/utils/amapConfig'
import { normalizeAreaCodes, getAreaName, stripAreaPrefix, getAreaCodesByAdcode, getAreaCodesByAddress, buildFullAddress } from './locationArea'
import { gcj02PointToWgs84LonLat, wgs84LonLatToGcj02Point, wgs84RouteToGcj02Text } from './coordinate'
import { confirmRoutePassage } from './routePassage'

const createNode = () => ({
  areaCodes: [],
  address: '',
  lonLat: '',
  contactName: '',
  contactPhone: '',
  radius: 500,
  planArriveTime: null,
  selectedAreaName: ''
})

const createForm = () => ({
  transportNo: '',
  vehicleId: null,
  vno: '',
  vco: '2',
  driverName: '',
  driverPhone: '',
  goodsName: '',
  planStartTime: null,
  planArriveTime: null,
  remark: '',
  routeId: null,
  waypointFenceCodes: [],
  start: createNode(),
  target: createNode(),
  transportStopovers: []
})

export default {
  name: 'WaybillForm',
  components: { CoordinateInput, WaybillLocationPicker, DriverFormDrawer, VehicleTreePicker, VehicleFormDialog, WaybillLocationInput, WaybillRouteDialog, WaybillFenceDialog, WaybillMapDialog, AddressBookInput, AddressBookDrawer },
  data() {
    return {
      saving: false,
      planningEnabled: false,
      routeFillId: '',
      sourceRoute: null,
      boundGeometry: '',
      routeApplySequence: 0,
      pendingSubmit: false,
      vehicleCreateVisible: false,
      formIdentity: '',
      formInitialized: false,
      formRequestSequence: 0,
      formSession: 0,
      submitRequestId: 0,
      locationPickerVisible: false,
      selectedNode: null,
      addressBookNode: null,
      addressBookToCreate: null,
      addressBookDrawerVisible: false,
      drivers: [],
      routes: [],
      routeLoading: false,
      routeDetailLoading: false,
      routeSnapshotWaybillNo: '',
      fences: [],
      fencePickerVisible: false,
      fenceKeyword: '',
      fenceLoading: false,
      fenceRequestSequence: 0,
      boundRoute: null,
      boundFences: [],
      selectedDriverId: '',
      driverDrawerVisible: false,
      vehicleManageVisible: false,
      routeDialogVisible: false,
      fenceDialogVisible: false,
      fenceReadonly: false,
      fenceToView: {},
      fenceSaving: false,
      fenceToAdd: '',
      mapDialogVisible: false,
      firstActivated: true,
      regionOptions: regionData,
      nodeLocationRequests: new WeakMap(),
      form: createForm(),
      rules: {
        transportNo: [{ required: true, message: '请生成或输入运单号', trigger: 'blur' }],
        planStartTime: [{ required: true, message: '请选择计划出发时间', trigger: 'change' }],
        planArriveTime: [{ required: true, message: '请选择计划结束时间', trigger: 'change' }]
      }
    }
  },
  computed: {
    isEdit() { return Boolean(this.$route.params.transportNo) },
    transportNodes() {
      return [
        { key: 'start', title: '起始地', type: 'origin', node: this.form.start },
        ...this.form.transportStopovers.map((node, index) => ({ key: node.key, title: `经停点 ${index + 1}`, type: 'stopover', index, node })),
        { key: 'target', title: '目的地', type: 'target', node: this.form.target }
      ]
    },
    driverOptions() {
      if (!this.selectedDriverId) return this.drivers
      const selected = {
        id: this.selectedDriverId,
        driverName: this.form.driverName,
        phone: this.form.driverPhone,
        disabled: !this.drivers.some(item => String(item.id) === String(this.selectedDriverId))
      }
      return [selected, ...this.drivers.filter(item => String(item.id) !== String(this.selectedDriverId))]
    },
    nodeGeometry() { return JSON.stringify(this.transportNodes.map(item => String(item.node.lonLat || ''))) },
    selectedRoute() {
      return this.planningEnabled && this.boundRoute && String(this.boundRoute.id) === String(this.form.routeId) && this.boundGeometry === this.nodeGeometry ? this.boundRoute : null
    },
    unavailableSelectedRoute() {
      return this.selectedRoute && !this.routes.some(item => item.id === this.selectedRoute.id)
    },
    selectedFences() {
      return this.form.waypointFenceCodes.map(code => this.boundFences.find(item => item.fenceCode === code) || this.fences.find(item => item.fenceCode === code)).filter(Boolean)
    },
    availableFences() {
      return this.fences.filter(item => Number(item.status) === 1 && !Number(item.deleted))
    },
    fencePickerOptions() {
      const options = [...this.availableFences, ...this.selectedFences.filter(item => !this.availableFences.some(fence => fence.fenceCode === item.fenceCode))]
      const keyword = this.fenceKeyword.trim().toLowerCase()
      return options.filter(item => `${item.fenceName} ${item.fenceCode}`.toLowerCase().includes(keyword))
    },
    mapWaybill() {
      return {
        transportNo: this.form.transportNo,
        vehicleNo: this.form.vno,
        driverName: this.form.driverName,
        driverPhone: this.form.driverPhone,
        goodsName: this.form.goodsName,
        planStartTime: this.form.planStartTime,
        planArriveTime: this.form.planArriveTime,
        routeId: this.selectedRoute ? this.form.routeId : null,
        route: this.selectedRoute ? { ...this.selectedRoute } : null,
        routeSnapshot: this.buildRouteSnapshot(),
        waypointFenceCodes: this.form.waypointFenceCodes,
        start: { ...this.form.start, areaName: this.getAreaName(this.form.start) },
        target: { ...this.form.target, areaName: this.getAreaName(this.form.target) }
      }
    },
    mapStopovers() {
      return this.form.transportStopovers.map(node => ({ ...node, areaName: this.getAreaName(node) }))
    }
  },
  watch: {
    planningEnabled(value) {
      if (!value) { this.routeApplySequence++; this.routeDetailLoading = false }
    },
    nodeGeometry(value) {
      if (this.boundRoute && value !== this.boundGeometry) this.invalidateRoute()
    }
  },
  created() { this.initializeForm(); if (typeof window.addEventListener === 'function') window.addEventListener('focus', this.onWindowFocus) },
  activated() {
    if (this.firstActivated) {
      this.firstActivated = false
      return
    }
    const identity = this.$route.params.transportNo || 'new'
    if (identity !== this.formIdentity || !this.formInitialized) this.initializeForm()
    else this.loadRoutes()
  },
  beforeRouteUpdate(to, from, next) {
    this.invalidateSubmission()
    next()
    this.$nextTick(() => this.initializeForm())
  },
  beforeRouteLeave(to, from, next) {
    this.invalidateSubmission()
    next()
  },
  deactivated() { this.invalidateSubmission() },
  beforeDestroy() { this.invalidateSubmission(); if (typeof window.removeEventListener === 'function') window.removeEventListener('focus', this.onWindowFocus) },
  methods: {
    fenceCoordinateText: wgs84RouteToGcj02Text,
    updateDialogVisibility(name, value, session) { if (session === this.formSession) this[name] = value },
    closeDraftDialogs() {
      this.formSession++
      this.routeApplySequence++
      this.routeLoading = false
      this.routeDetailLoading = false
      this.fencePickerVisible = false
      this.fenceLoading = false
      this.vehicleCreateVisible = false
      this.driverDrawerVisible = false
      this.fenceDialogVisible = false
      this.routeDialogVisible = false
      this.locationPickerVisible = false
      this.addressBookDrawerVisible = false
      this.mapDialogVisible = false
      this.fenceSaving = false
      this.selectedNode = null
      this.addressBookNode = null
    },
    invalidateSubmission() {
      this.closeDraftDialogs()
      this.submitRequestId += 1
      this.formRequestSequence++
      this.saving = false
      this.nodeLocationRequests = new WeakMap()
      this.pendingSubmit = false
    },
    async initializeForm() {
      this.closeDraftDialogs()
      const requestId = ++this.formRequestSequence
      this.formInitialized = false
      this.formIdentity = this.$route.params.transportNo || 'new'
      this.planningEnabled = false
      this.routeFillId = ''
      this.sourceRoute = null
      this.pendingSubmit = false
      this.boundGeometry = ''
      this.nodeLocationRequests = new WeakMap()
      this.form = createForm()
      this.selectedDriverId = ''
      this.boundRoute = null
      this.routeSnapshotWaybillNo = ''
      this.boundFences = []
      this.fenceKeyword = ''
      this.vehicleManageVisible = false
      this.selectedNode = null
      this.addressBookNode = null
      this.addressBookToCreate = null
      this.addressBookDrawerVisible = false
      this.fenceToAdd = ''
      this.fenceReadonly = false
      this.fenceToView = {}
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      await Promise.all([this.loadDrivers(), this.loadRoutes(), this.loadFences()])
      if (requestId !== this.formRequestSequence) return
      if (this.isEdit) await this.loadWaybill(requestId)
      if (requestId !== this.formRequestSequence) return
      this.formInitialized = true
      if (this.$route.query.routePlanning === '1') { this.planningEnabled = true; this.openRoutePlanner() }
    },
    generateTransportNo() {
      const random = String(Math.floor(Math.random() * 10000)).padStart(4, '0')
      this.form.transportNo = `${dayjs().format('YYYYMMDDHHmmss')}${random}`
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate('transportNo'))
    },
    async openWaybillMap() {
      if (!await this.loadSelectedRouteGeometry()) return
      this.mapDialogVisible = true
    },
    async loadDrivers() {
      try {
        const res = await getDriverList()
        if (!isRequestSuccess(res)) throw new Error(res.msg || '刷新失败')
        this.drivers = res.data || []
      } catch (e) { this.$message.warning('司机候选刷新失败，请稍后重试') }
    },
    async loadRoutes() {
      if (this.routeLoading) return
      const session = this.formSession
      this.routeLoading = true
      try {
        const res = await getAvailableRoutes()
        if (session !== this.formSession) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '刷新失败')
        this.routes = res.data || []
      } catch (e) {
        if (session === this.formSession) this.$message.warning('线路候选刷新失败，可重新展开下拉重试')
      } finally {
        if (session === this.formSession) this.routeLoading = false
      }
    },
    async loadFences() {
      const requestId = ++this.fenceRequestSequence
      const session = this.formSession
      const isCurrent = () => requestId === this.fenceRequestSequence && session === this.formSession
      this.fenceLoading = true
      try {
        const res = await getFenceList({ status: 1 })
        if (!isCurrent()) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '刷新失败')
        const candidates = res.data || []
        const missingFences = this.selectedFences.filter(fence => !candidates.some(item => item.fenceCode === fence.fenceCode))
        this.boundFences = this.boundFences.filter(fence => !candidates.some(item => item.fenceCode === fence.fenceCode))
        missingFences.forEach(fence => {
          if (!this.boundFences.some(item => item.fenceCode === fence.fenceCode)) this.boundFences.push({ ...fence })
        })
        this.fences = candidates
      } catch (e) {
        if (isCurrent()) this.$message.warning('围栏候选刷新失败，请稍后重试')
      } finally {
        if (isCurrent()) this.fenceLoading = false
      }
    },
    async loadWaybill(requestId = this.formRequestSequence) {
      const transportNo = this.$route.params.transportNo
      const isCurrent = () => requestId === this.formRequestSequence && transportNo === this.$route.params.transportNo
      try {
        const res = await getWaybillDetail({ transportNo, includeRouteGeometry: false })
        if (!isRequestSuccess(res)) throw new Error(res.msg || '运单不存在')
        if (!isCurrent()) return
        const data = res.data || {}
        const waybill = data.waybill || data
        if (Number(waybill.transportStatus) !== 0) throw new Error('仅待开始运单允许编辑')
        this.form = {
          ...createForm(),
          transportNo: waybill.waybillNo || '',
          vehicleId: waybill.vehicleId || null,
          vno: waybill.vehicleNo || '',
          vco: String(waybill.plateColor === null || waybill.plateColor === undefined ? '2' : waybill.plateColor),
          driverName: waybill.driverName || '',
          driverPhone: waybill.driverPhone || '',
          goodsName: waybill.cargoName || '',
          planStartTime: this.toPlanTimestamp(waybill.planDepartTime),
          planArriveTime: this.toPlanTimestamp(waybill.planArriveTime),
          remark: waybill.remark || '',
          routeId: waybill.routeId || '',
          waypointFenceCodes: String(waybill.waypointFenceCode || '').split(',').map(item => item.trim()).filter(Boolean),
          start: this.buildRouteNode({ areaCodes: waybill.startAreaCodes, areaName: waybill.startAreaName, address: waybill.startAddress, lonLat: waybill.startLonlat, contactName: waybill.startContactName, contactPhone: waybill.startContactPhone, radius: waybill.startFenceRadius }),
          target: this.buildRouteNode({ areaCodes: waybill.endAreaCodes, areaName: waybill.endAreaName, address: waybill.endAddress, lonLat: waybill.endLonlat, contactName: waybill.endContactName, contactPhone: waybill.endContactPhone, radius: waybill.endFenceRadius }),
          transportStopovers: (data.stopovers || []).map(item => this.buildRouteNode({ areaCodes: item.stopoverAreaCodes, areaName: item.stopoverAreaName, address: item.stopoverAddress, lonLat: item.stopoverLonlat, contactName: item.stopoverContactName, contactPhone: item.stopoverContactPhone, radius: item.stopoverRadius, planArriveTime: item.planArriveTime }))
        }
        this.selectedDriverId = waybill.driverId || ''
        this.planningEnabled = Boolean(waybill.routeId)
        this.sourceRoute = data.route || null
        this.boundRoute = data.route || null
        this.routeSnapshotWaybillNo = transportNo
        this.boundGeometry = this.nodeGeometry
        if (!this.boundRoute) this.form.routeId = null
        this.boundFences = data.fences || []
        this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      } catch (e) {
        if (!isCurrent()) return
        this.$message.error(e.message || '加载运单失败')
        this.backToList()
      }
    },
    routeOptionLabel(route) {
      const mileage = route.totalDileage === null || route.totalDileage === undefined ? '-' : `${Number(route.totalDileage).toFixed(2)}公里`
      return `${route.routeName}（${mileage}）`
    },
    routeDurationText(value) {
      if (!value) return '-'
      const total = Number(value)
      const hours = Math.floor(total / 3600)
      const minutes = Math.ceil((total % 3600) / 60)
      return hours ? `${hours}小时${minutes}分` : `${minutes}分`
    },
    toPlanTimestamp(value) {
      if (value === null || value === undefined || value === '') return null
      const time = dayjs(value).valueOf()
      return Number.isFinite(time) ? time : null
    },
    buildRouteNode(source = {}) {
      const areaCodes = normalizeAreaCodes(source.areaCodes)
      const areaName = getAreaName(areaCodes) || source.areaName || ''
      return {
        key: `route-stopover-${Date.now()}-${Math.random()}`,
        areaCodes,
        address: stripAreaPrefix(source.address, areaName),
        lonLat: source.lonLat || source.lonlat || '',
        contactName: source.contactName || '',
        contactPhone: source.contactPhone || '',
        radius: Number(source.radius) || 500,
        planArriveTime: this.toPlanTimestamp(source.planArriveTime),
        selectedAreaName: areaName
      }
    },
    parseRouteWaypoints(value) {
      try {
        const nodes = JSON.parse(value || '[]')
        return Array.isArray(nodes) ? nodes.map(item => this.buildRouteNode(item)) : []
      } catch (e) {
        return []
      }
    },
    hasRouteGeometry(route) { return String(route && route.routeList || '').split('|').filter(value => this.isValidLonLat(value)).length >= 2 },
    invalidateRoute() {
      this.routeApplySequence++
      this.routeDetailLoading = false
      this.form.routeId = null
      this.boundRoute = null
      this.routeSnapshotWaybillNo = ''
      this.boundGeometry = ''
    },
    buildRouteSnapshot() {
      const route = this.selectedRoute
      if (!route || !this.hasRouteGeometry(route)) return null
      return { routeName: route.routeName || '', routeList: route.routeList, drivingStrategy: route.drivingStrategy == null ? null : Number(route.drivingStrategy), totalDileage: route.totalDileage == null ? null : route.totalDileage, totalDuration: route.totalDuration == null ? null : route.totalDuration, tolls: route.tolls == null ? null : route.tolls, tollDistance: route.tollDistance == null ? null : route.tollDistance }
    },
    onWindowFocus() { if (!this._inactive && !this._isDestroyed) this.loadRoutes() },
    openRouteManage() { window.open(this.$router.resolve({ path: '/routes' }).href, '_blank') },
    openVehicleManage() { window.open(this.$router.resolve({ path: '/vehicles' }).href, '_blank') },
    async openRoutePlanner() {
      if (await this.loadSelectedRouteGeometry()) this.routeDialogVisible = true
    },
    async loadSelectedRouteGeometry() {
      if (this.routeDetailLoading) return false
      const route = this.selectedRoute
      if (!route || this.hasRouteGeometry(route)) return true
      const requestId = ++this.routeApplySequence
      this.routeDetailLoading = true
      try {
        // 表单只保留摘要；打开规划或地图时才读取所选版本的几何。
        const response = this.routeSnapshotWaybillNo
          ? await getWaybillDetail({ transportNo: this.routeSnapshotWaybillNo })
          : await getRouteDetail(route.id)
        if (requestId !== this.routeApplySequence || this.selectedRoute !== route) return false
        const detail = this.routeSnapshotWaybillNo ? response.data && response.data.route : response.data
        if (!isRequestSuccess(response) || !detail || String(detail.id) !== String(route.id)) throw new Error(response.msg || '线路加载失败')
        const nodes = value => [value.startLonlat, ...this.parseRouteWaypoints(value.waypoints).map(node => node.lonLat), value.endLonlat]
        const before = nodes(route), after = nodes(detail)
        if (before.length !== after.length || before.some((point, index) => !this.sameLocation(point, after[index]))) throw new Error('线路已更新，请重新选择')
        this.boundRoute = { ...route, ...detail }
        return true
      } catch (error) {
        if (requestId === this.routeApplySequence) this.$message.error(error.msg || error.message || '线路加载失败，请重试')
        return false
      } finally {
        if (requestId === this.routeApplySequence) this.routeDetailLoading = false
      }
    },
    mergeNodeSupplement(node, previous) {
      if (!previous) return node
      return { ...node, contactName: previous.contactName || node.contactName, contactPhone: previous.contactPhone || node.contactPhone, radius: previous.radius, planArriveTime: previous.planArriveTime, detailsExpanded: previous.detailsExpanded }
    },
    applyRouteNodes(route, plannedForm) {
      const previous = this.form.transportStopovers
      const start = plannedForm ? this.buildRouteNode(plannedForm.start) : this.buildRouteNode({ areaCodes: route.startAreaCodes, areaName: route.startAreaName, address: route.startAddress, lonLat: route.startLonlat, contactName: route.startContactName, contactPhone: route.startContactPhone, radius: route.startRadius })
      const target = plannedForm ? this.buildRouteNode(plannedForm.end) : this.buildRouteNode({ areaCodes: route.endAreaCodes, areaName: route.endAreaName, address: route.endAddress, lonLat: route.endLonlat, contactName: route.endContactName, contactPhone: route.endContactPhone, radius: route.endRadius })
      const stopovers = plannedForm ? plannedForm.waypoints.map(node => this.buildRouteNode(node)) : this.parseRouteWaypoints(route.waypoints)
      this.form.start = this.mergeNodeSupplement(start, this.form.start)
      this.form.target = this.mergeNodeSupplement(target, this.form.target)
      this.form.transportStopovers = stopovers.map(node => this.mergeNodeSupplement(node, previous.find(old => this.sameLocation(old.lonLat, node.lonLat))))
      this.sourceRoute = { ...route }
      this.routeSnapshotWaybillNo = ''
      this.boundRoute = route.routeList === undefined || this.hasRouteGeometry(route) ? { ...route } : null
      this.form.routeId = this.boundRoute ? route.id : null
      this.boundGeometry = this.nodeGeometry
    },
    async applyRouteTemplate(routeId) {
      this.routeFillId = ''
      const route = this.routes.find(item => String(item.id) === String(routeId))
      if (!route) return
      const requestId = ++this.routeApplySequence
      this.routeDetailLoading = false
      const incoming = [route.startLonlat, ...this.parseRouteWaypoints(route.waypoints).map(node => node.lonLat), route.endLonlat]
      const current = this.transportNodes.map(item => item.node.lonLat)
      if (this.transportNodes.some(item => item.node.address || item.node.lonLat) && (incoming.length !== current.length || incoming.some((point, index) => !this.sameLocation(point, current[index])))) {
        try { await this.$confirm('选择此线路将替换当前运输节点；起终点补充信息保留，经停点按相同地点保留，移除节点的补充信息将一并移除。', '替换运输节点', { type: 'warning', confirmButtonText: '替换节点', cancelButtonText: '取消' }) } catch (error) { return }
      }
      if (requestId !== this.routeApplySequence) return
      this.applyRouteNodes(route)
      const nodes = this.transportNodes.map(item => item.node)
      const results = await Promise.all(nodes.map(node => this.completeNodeArea(node)))
      if (requestId !== this.routeApplySequence || nodes.some(node => !this.transportNodes.some(item => item.node === node))) return
      if (results.some(result => !result)) this.$message.warning('已回填节点，部分省市区未能识别，请通过地图选点补齐')
      if (!this.boundRoute) this.$message.warning('此线路缺少有效几何，请重新规划')
    },
    onRouteCancelled(session = this.formSession) { if (session === this.formSession) this.pendingSubmit = false },
    async onRouteSaved(route, plannedForm, session = this.formSession) {
      if (session !== this.formSession) return
      if (!route || !route.id) return
      this.applyRouteNodes(route, plannedForm)
      const continueSubmit = this.pendingSubmit
      this.pendingSubmit = false
      this.loadRoutes()
      if (continueSubmit) await this.submit()
    },
    sameLocation(left, right) {
      if (left === right) return true
      if (!this.isValidLonLat(left) || !this.isValidLonLat(right)) return false
      const a = String(left).split(',').map(Number), b = String(right).split(',').map(Number)
      return Math.abs(a[0] - b[0]) < 0.000001 && Math.abs(a[1] - b[1]) < 0.000001
    },
    onDriverChange(id) {
      const driver = this.drivers.find((item) => String(item.id) === String(id))
      this.form.driverName = driver ? driver.driverName : ''
      this.form.driverPhone = driver ? driver.phone : ''
    },
    onVehicleManualInput() {
      this.form.vehicleId = null
      this.form.vco = '2'
    },
    onVehicleSelect(vehicle) {
      this.form.vehicleId = vehicle.vehicleId || vehicle.id
      this.form.vno = vehicle.vehicleNo
      this.form.vco = String(vehicle.plateColor)
    },
    onVehicleManageClosed() {
      this.$nextTick(() => {
        const picker = this.$refs.vehiclePicker
        if (picker && typeof picker.refresh === 'function') picker.refresh()
      })
    },
    onVehicleSaved(vehicle, session = this.formSession) {
      if (session !== this.formSession) return
      this.onVehicleSelect(vehicle)
      this.vehicleCreateVisible = false
      this.onVehicleManageClosed()
    },
    async onDriverSaved(driver, session = this.formSession) {
      if (session !== this.formSession) return
      this.drivers = [driver, ...this.drivers.filter(item => String(item.id) !== String(driver.id))]
      this.selectedDriverId = driver.id
      this.form.driverName = driver.driverName
      this.form.driverPhone = driver.phone
      this.driverDrawerVisible = false
      await this.loadDrivers()
    },
    addStopover() {
      if (this.form.transportStopovers.length >= 8) return
      this.form.transportStopovers.push({ key: `${Date.now()}-${this.form.transportStopovers.length}`, ...createNode() })
    },
    moveStopover(index, direction) {
      const target = index + direction
      if (target < 0 || target >= this.form.transportStopovers.length) return
      const nodes = this.form.transportStopovers
      const node = nodes[index]
      this.$set(nodes, index, nodes[target])
      this.$set(nodes, target, node)
    },
    removeStopover(index) {
      this.form.transportStopovers.splice(index, 1)
    },
    addExistingFence() {
      if (!this.fenceToAdd) {
        this.$message.warning('请选择要关联的运单围栏')
        return
      }
      if (!this.form.waypointFenceCodes.includes(this.fenceToAdd)) this.form.waypointFenceCodes.push(this.fenceToAdd)
      this.fenceToAdd = ''
    },
    removeFence(fenceCode) {
      this.form.waypointFenceCodes = this.form.waypointFenceCodes.filter(code => code !== fenceCode)
    },
    openFenceCreate() {
      this.fenceReadonly = false
      this.fenceToView = {}
      this.fenceDialogVisible = true
    },
    viewFence(fence) {
      this.fenceReadonly = true
      this.fenceToView = { ...fence }
      this.fenceDialogVisible = true
    },
    async onSubmitFence(fence, session = this.formSession) {
      if (session !== this.formSession || this.fenceSaving) return
      const isCurrent = () => session === this.formSession
      this.fenceSaving = true
      try {
        const res = await saveFence(fence, { createOnly: true })
        if (!isCurrent()) return
        if (!isRequestSuccess(res)) throw new Error(res.msg || '保存失败')
        const fenceCode = res.data && typeof res.data === 'object' ? res.data.fenceCode : res.data || fence.fenceCode
        const created = { status: 1, ...fence, ...(res.data && typeof res.data === 'object' ? res.data : {}), fenceCode }
        // 新增结果立即进入候选，阻止新增前发出的刷新覆盖它。
        this.fenceRequestSequence++
        this.fenceLoading = false
        this.fences = [...this.fences.filter(item => item.fenceCode !== fenceCode), created]
        this.boundFences = [...this.boundFences.filter(item => item.fenceCode !== fenceCode), created]
        if (!this.form.waypointFenceCodes.includes(fenceCode)) this.form.waypointFenceCodes.push(fenceCode)
        this.fenceDialogVisible = false
        this.$message.success('运单围栏创建成功，已关联到当前运单')
      } catch (e) {
        if (isCurrent()) this.$message.error(e.message || '围栏保存失败')
      } finally {
        if (isCurrent()) this.fenceSaving = false
      }
    },
    fenceTypeText(type) { return Number(type) === 1 ? '圆形围栏' : '多边形围栏' },
    eventTypeText(type) { return { 1: '驶入', 2: '驶出', 3: '区域内停车', 4: '驶入+驶出', 5: '驶入+驶出+驶出超时', 6: '驶入+区域内停车', 7: '驶入+驶出+区域内停车', 8: '驶入+驶出+区域内停车+驶出超时' }[Number(type)] || '-' },
    onAreaChange(node) {
      const oldAreaName = node.selectedAreaName || ''
      node.address = stripAreaPrefix(node.address, oldAreaName)
      node.selectedAreaName = this.getAreaName(node)
      this.nodeLocationRequests.delete(node)
      if (oldAreaName !== node.selectedAreaName) node.lonLat = ''
    },
    applyAddressBook(node, addressBook) {
      this.nodeLocationRequests.delete(node)
      node.areaCodes = normalizeAreaCodes(addressBook.areaCodes)
      if (node.areaCodes.length !== 3) {
        const areaCodes = getAreaCodesByAddress(addressBook.areaName)
        const addressCodes = areaCodes.length ? areaCodes : getAreaCodesByAddress(addressBook.address)
        if (addressCodes.length) node.areaCodes = addressCodes
      }
      node.selectedAreaName = this.getAreaName(node) || addressBook.areaName || ''
      node.address = stripAreaPrefix(addressBook.address, node.selectedAreaName)
      if (addressBook.longitude !== null && addressBook.longitude !== undefined && addressBook.latitude !== null && addressBook.latitude !== undefined) {
        const lonLat = `${addressBook.longitude},${addressBook.latitude}`
        if (!this.sameLocation(node.lonLat, lonLat)) node.lonLat = lonLat
      } else node.lonLat = ''
      node.contactName = addressBook.contactName || ''
      node.contactPhone = addressBook.contactPhone || ''
    },
    openAddressBookCreate(node) {
      this.addressBookNode = node
      this.addressBookToCreate = null
      this.addressBookDrawerVisible = true
    },
    onAddressBookSaved(addressBook, session = this.formSession) {
      if (session !== this.formSession) return
      if (this.addressBookNode && addressBook && typeof addressBook === 'object') this.applyAddressBook(this.addressBookNode, addressBook)
      this.addressBookNode = null
      this.addressBookToCreate = null
    },
    openLocationPicker(node) {
      this.selectedNode = node
      this.locationPickerVisible = true
    },
    createNodeLocationGuard(node) {
      const requestId = (this.nodeLocationRequests.get(node) || 0) + 1
      this.nodeLocationRequests.set(node, requestId)
      const snapshot = { lonLat: node.lonLat, address: node.address, areaCodes: this.getAreaCodes(node) }
      return () => this.nodeLocationRequests.get(node) === requestId
        && this.transportNodes.some(item => item.node === node)
        && node.lonLat === snapshot.lonLat && node.address === snapshot.address && this.getAreaCodes(node) === snapshot.areaCodes
    },
    async completeNodeArea(node) {
      if (normalizeAreaCodes(node.areaCodes).length === 3) return true
      const point = wgs84LonLatToGcj02Point(node.lonLat)
      if (!point) return false
      const isCurrent = this.createNodeLocationGuard(node)
      try {
        setAmapSecurityConfig()
        await loadAmapSDK(['AMap.Geocoder'])
        const result = await new Promise(resolve => {
          new window.AMap.Geocoder().getAddress(point, (status, response) => resolve(status === 'complete' && response.regeocode ? response.regeocode : null))
        })
        if (!isCurrent()) return true
        const component = result && result.addressComponent
        const codes = getAreaCodesByAdcode(component && component.adcode, component || {})
        if (codes.length !== 3) return false
        // 只补地区，不用短地址全国重定位，更不改路线原始84坐标。
        node.areaCodes = codes
        node.selectedAreaName = this.getAreaName(node)
        node.address = stripAreaPrefix(node.address, node.selectedAreaName)
        return true
      } catch (error) { return !isCurrent() }
    },
    async resolveNodeCoordinate(node) {
      const codes = normalizeAreaCodes(node.areaCodes)
      if (codes.length !== 3) {
        this.$message.warning('请先选择完整省市区，再解析详细地址坐标')
        return
      }
      const detailAddress = String(node.address || '').trim()
      if (!detailAddress) {
        this.$message.warning('请先填写详细地址，不能将地区中心作为装卸点')
        return
      }
      const address = buildFullAddress(codes, detailAddress).replace('市辖区', '').replace('省直辖县级行政区划', '')
      const adcode = codes[2].length === 9 ? `${codes[1]}00` : codes[2]
      const isCurrent = this.createNodeLocationGuard(node)
      try {
        setAmapSecurityConfig()
        await loadAmapSDK(['AMap.Geocoder'])
        const geocoded = await new Promise((resolve) => {
          new window.AMap.Geocoder({ city: adcode }).getLocation(address, (status, result) => {
            if (status !== 'complete' || !result.geocodes || !result.geocodes.length) {
              resolve(null)
              return
            }
            resolve(result.geocodes[0])
          })
        })
        if (!isCurrent()) return
        if (!geocoded) {
          this.$message.warning('未解析到坐标，请使用地图选点')
          return
        }
        const resultAdcode = String(geocoded.adcode)
        if (resultAdcode !== adcode && !(codes[2].length === 9 && resultAdcode === codes[2].slice(0, 6))) {
          this.$message.warning('解析结果与所选省市区不一致，请核对地址或使用地图选点')
          return
        }
        if (['国家', '省', '市', '区县'].includes(geocoded.level)) {
          this.$message.warning('仅解析到地区中心，请使用地图选点选择精确装卸位置')
          return
        }
        const point = [geocoded.location.getLng(), geocoded.location.getLat()]
        node.lonLat = gcj02PointToWgs84LonLat(point[0], point[1])
        this.$message.success('坐标已自动解析')
      } catch (e) {
        if (isCurrent()) this.$message.warning('坐标解析失败，请使用地图选点')
      }
    },
    onNodeAddressInput(node) {
      this.nodeLocationRequests.delete(node)
      node.lonLat = ''
    },
    applyNodeLocation(node, location) {
      this.nodeLocationRequests.delete(node)
      if (!this.sameLocation(node.lonLat, location.lonLat)) node.lonLat = location.lonLat
      if (Array.isArray(location.areaCodes) && location.areaCodes.length) node.areaCodes = normalizeAreaCodes(location.areaCodes)
      node.selectedAreaName = this.getAreaName(node) || location.areaName || ''
      if (location.address) node.address = stripAreaPrefix(location.address, node.selectedAreaName)
    },
    applyPickedLocation(location, session = this.formSession) {
      if (session !== this.formSession) return
      if (!this.selectedNode) return
      this.applyNodeLocation(this.selectedNode, location)
      this.selectedNode = null
    },
    getAreaCodes(node) {
      return Array.isArray(node.areaCodes) ? node.areaCodes.join(',') : ''
    },
    getAreaName(node) {
      return getAreaName(node.areaCodes)
    },
    buildAddress(node) {
      return node.address || ''
    },
    isValidPhone(value) {
      return !value || /^[0-9-]{6,20}$/.test(value)
    },
    isValidLonLat(value) {
      const parts = String(value || '').trim().split(',')
      if (parts.some(item => !item.trim())) return false
      const values = parts.map(Number)
      return values.length === 2 && Number.isFinite(values[0]) && Number.isFinite(values[1]) && Math.abs(values[0]) <= 180 && Math.abs(values[1]) <= 90
    },
    isValidNode(node) {
      return normalizeAreaCodes(node.areaCodes).length === 3 && String(node.address || '').trim() && this.isValidLonLat(node.lonLat)
    },
    validateNodes() {
      if (!this.form.vno || !this.form.vco) {
        this.$message.warning('请选择有效车辆或填写车牌号')
        return false
      }
      if (!this.isValidPhone(this.form.driverPhone)) {
        this.$message.warning('司机电话格式不正确')
        return false
      }
      if (!this.isValidNode(this.form.start) || !this.isValidNode(this.form.target)) {
        this.$message.warning('请通过地址联想或地图选点，完成起始地和目的地定位')
        return false
      }
      const invalidStopover = this.form.transportStopovers.some((node) => !this.isValidNode(node) || !this.isValidPhone(node.contactPhone))
      if (invalidStopover) {
        this.$message.warning('请通过地址联想或地图选点，完成每个经停点定位并核对电话')
        return false
      }
      if (!this.isValidPhone(this.form.start.contactPhone) || !this.isValidPhone(this.form.target.contactPhone)) {
        this.$message.warning('节点联系电话格式不正确')
        return false
      }
      if (this.form.planStartTime >= this.form.planArriveTime) {
        this.$message.warning('计划结束时间必须晚于计划出发时间')
        return false
      }
      return true
    },
    buildStopoverPayload(node, index) {
      return {
        stopoverSeq: index + 1,
        stopoverAddress: this.buildAddress(node),
        stopoverLonlat: node.lonLat,
        stopoverRadius: node.radius,
        planArriveTime: node.planArriveTime,
        stopoverAreaCodes: this.getAreaCodes(node),
        stopoverAreaName: this.getAreaName(node),
        stopoverContactName: node.contactName,
        stopoverContactPhone: node.contactPhone
      }
    },
    buildPayload() {
      return {
        transportNo: this.form.transportNo,
        vehicleId: this.form.vehicleId,
        vehicleNo: this.form.vno,
        plateColor: Number(this.form.vco),
        driverId: this.selectedDriverId ? String(this.selectedDriverId) : null,
        driverName: this.form.driverName,
        driverPhone: this.form.driverPhone,
        cargoName: this.form.goodsName,
        planDepartTime: this.form.planStartTime,
        planArriveTime: this.form.planArriveTime,
        routeType: 1,
        routeId: this.selectedRoute ? this.form.routeId : null,
        ...(this.selectedRoute && !this.hasRouteGeometry(this.selectedRoute) ? {} : { routeSnapshot: this.buildRouteSnapshot() }),
        waypointFenceCode: this.form.waypointFenceCodes.join(','),
        remark: this.form.remark,
        startAddress: this.buildAddress(this.form.start),
        startLonlat: this.form.start.lonLat,
        startFenceRadius: this.form.start.radius,
        startAreaCodes: this.getAreaCodes(this.form.start),
        startAreaName: this.getAreaName(this.form.start),
        startContactName: this.form.start.contactName,
        startContactPhone: this.form.start.contactPhone,
        endAddress: this.buildAddress(this.form.target),
        endLonlat: this.form.target.lonLat,
        endFenceRadius: this.form.target.radius,
        endAreaCodes: this.getAreaCodes(this.form.target),
        endAreaName: this.getAreaName(this.form.target),
        endContactName: this.form.target.contactName,
        endContactPhone: this.form.target.contactPhone,
        stopovers: this.form.transportStopovers.map(this.buildStopoverPayload)
      }
    },
    async submit() {
      if (this.saving || this.routeDetailLoading) return
      this.saving = true
      const requestId = ++this.submitRequestId
      const isCurrent = () => requestId === this.submitRequestId
      try {
        try { await this.$refs.form.validate() } catch (e) { return }
        if (!isCurrent() || !this.validateNodes()) return
        if (this.planningEnabled && !this.selectedRoute) {
          this.pendingSubmit = true
          this.openRoutePlanner()
          return
        }
        // 校验和保存共用同一快照，保留当前运单节点与围栏选择。
        const payload = this.buildPayload()
        const isEdit = this.isEdit
        const transportNo = this.$route.params.transportNo
        const listState = this.$route.query.listState
        if (payload.routeId) {
          const nodes = [
            { code: 'start', name: `起点：${payload.startAddress}`, lonLat: payload.startLonlat, radius: payload.startFenceRadius },
            ...payload.stopovers.map((node, index) => ({ code: `stopover-${index + 1}`, name: `经停点 ${index + 1}：${node.stopoverAddress}`, lonLat: node.stopoverLonlat, radius: node.stopoverRadius })),
            { code: 'end', name: `目的地：${payload.endAddress}`, lonLat: payload.endLonlat, radius: payload.endFenceRadius }
          ]
          const input = { routeId: payload.routeId, routeList: payload.routeSnapshot && payload.routeSnapshot.routeList, routeSnapshot: payload.routeSnapshot, transportNo: this.routeSnapshotWaybillNo || undefined, nodes, fenceCodes: payload.waypointFenceCode ? payload.waypointFenceCode.split(',') : [] }
          if (!await confirmRoutePassage(this, input, isCurrent) || !isCurrent()) return
        }
        const res = isEdit ? await updateWaybill(transportNo, payload) : await createWaybill(payload)
        if (!isCurrent()) return
        if (isRequestSuccess(res)) {
          this.$message.success('运单已保存')
          this.$router.replace({ name: 'LingDongInTransitName', query: { listState } })
        } else this.$message.error(res.msg || '保存失败')
      } catch (e) {
        if (isCurrent()) this.$message.error(e.msg || e.message || '保存失败，请稍后重试')
      } finally {
        if (isCurrent()) this.saving = false
      }
    },
    backToList() {
      if (this.saving) return
      this.$router.push({ name: 'LingDongInTransitName', query: { listState: this.$route.query.listState } })
    }
  }
}
</script>

<style scoped>
.waybill-form-page { min-height: 100%; padding: 20px 24px 86px; box-sizing: border-box; background: #f5f7fb; }
.page-heading { display: flex; align-items: center; justify-content: space-between; gap: 12px; max-width: 1280px; margin: 0 auto 16px; }.page-heading__actions { display: flex; gap: 10px; }.page-heading__actions > .el-button { height: 40px; margin: 0; }.page-heading__title { color: #172b4d; font-size: 20px; font-weight: 600; line-height: 28px; }.page-heading__sub { margin-top: 4px; color: #8a94a6; font-size: 13px; }
.waybill-form { max-width: 1280px; margin: 0 auto; }.form-section { margin-bottom: 14px; padding: 18px 20px; border-radius: 6px; background: #fff; box-shadow: 0 2px 8px rgba(27,49,84,.05); }.section-title { margin-bottom: 18px; color: #1f2d3d; font-size: 16px; font-weight: 600; }.section-title::before { display: inline-block; width: 3px; height: 16px; margin-right: 9px; vertical-align: -2px; border-radius: 2px; background: #2f78ed; content: ''; }
.section-fields { max-width: 912px; margin: 0 auto; }
.waybill-form ::v-deep .el-form-item { min-width: 0; margin-bottom: 18px; }.waybill-form ::v-deep .el-form-item__label { color: #475467; }.waybill-form ::v-deep .el-form-item__content { min-width: 0; }.form-grid { display: grid; grid-template-columns: repeat(2, minmax(0, 440px)); gap: 0 24px; }.form-grid ::v-deep .el-form-item__content, .node-details ::v-deep .el-form-item__content { max-width: 330px; }.form-grid ::v-deep .el-select { width: 100%; }
.inline-fields { display: flex; gap: 8px; max-width: 330px; }.inline-fields > * { flex: 1; min-width: 0; }.inline-fields > .el-button { flex: 0 0 64px; width: 64px; height: 40px; margin: 0; padding-right: 0; padding-left: 0; }.planning-row ::v-deep .el-form-item__content { display: flex; align-items: center; flex-wrap: wrap; gap: 16px; }.planning-row ::v-deep .el-select { width: 280px; }.planning-row .el-button { height: 40px; margin: 0; }
.node-address-label { display: inline-flex; flex-direction: column; align-items: flex-end; vertical-align: middle; line-height: 20px; }.node-address-label .node-details-toggle { margin: 0; padding: 0 !important; font-size: 11px !important; line-height: 16px; }.node-details-toggle i { margin-left: 2px; }.node-main-row { display: flex; align-items: flex-start; flex-wrap: wrap; gap: 0 12px; }.node-address-item { flex: 0 1 570px; width: 570px; max-width: 100%; }.node-address-fields { display: flex; gap: 8px; width: 460px; max-width: 100%; }.node-address-fields .waybill-location-input { flex: 1; min-width: 0; }.node-address-fields > .el-button { flex: none; height: 40px; margin: 0; }.node-time-item { flex: 0 1 330px; max-width: 100%; }.node-time-item ::v-deep .el-date-editor { width: 220px; max-width: 100%; }.node-operations { display: flex; flex: 0 0 calc(100% - 110px); gap: 12px; margin: 0 0 18px 110px; }.node-operations > .el-button { height: 40px; margin: 0; }.node-details { display: grid; grid-template-columns: repeat(2, minmax(0, 440px)); gap: 0 24px; margin-bottom: 12px; padding: 14px 0 0; border-radius: 4px; background: #f8fafc; }.node-details ::v-deep .el-cascader, .node-details ::v-deep .el-input-number { width: 100%; }.node-extra-actions { margin: -4px 0 12px 110px; color: #98a2b3; font-size: 12px; }.node-extra-actions span { margin-left: 12px; }.plan-summary-row ::v-deep .el-form-item__content { display: flex; align-items: center; flex-wrap: wrap; gap: 14px; }.plan-summary-row ::v-deep .el-form-item__content > .el-button { height: 40px; margin: 0; }.route-selected { color: #529b2e; font-size: 13px; }.route-template-tip { color: #98a2b3; font-size: 13px; }.danger-button { color: #e64545; }
.fence-actions { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }.fence-actions > .el-button { height: 40px; margin: 0; }.fence-picker { width: 330px; max-width: 100%; }.fence-tags { display: flex; flex-wrap: wrap; gap: 8px; margin-top: 8px; }.fence-tag-name { cursor: pointer; }.remark-row ::v-deep .el-form-item__content { max-width: 794px; }.form-actions { position: fixed; right: 0; bottom: 0; left: 0; z-index: 20; display: flex; justify-content: center; gap: 12px; padding: 14px; border-top: 1px solid #e6eaf0; background: rgba(255,255,255,.96); box-shadow: 0 -2px 10px rgba(31,45,61,.05); }.form-actions > .el-button { height: 40px; margin: 0; }
.planning-row ::v-deep .el-form-item__content::before, .planning-row ::v-deep .el-form-item__content::after, .plan-summary-row ::v-deep .el-form-item__content::before, .plan-summary-row ::v-deep .el-form-item__content::after { content: none; }
.fence-picker-panel__toolbar { display: flex; gap: 8px; margin-bottom: 10px; }.fence-picker-panel__toolbar > .el-input { flex: 1; }.fence-picker-panel__list { max-height: 260px; min-height: 40px; overflow-y: auto; }.fence-picker-panel__list ::v-deep .el-checkbox { display: flex; align-items: flex-start; margin: 0; padding: 8px 0; }.fence-picker-panel__list ::v-deep .el-checkbox__input { margin-top: 2px; }.fence-picker-panel__list ::v-deep .el-checkbox__label { white-space: normal; word-break: break-all; line-height: 20px; }.fence-node-table { margin-top: 12px; }.fence-table-actions { display: flex; gap: 4px; }.fence-table-actions > .el-button { margin: 0; padding: 0 !important; }.fence-empty { margin-top: 8px; }
@media (max-width: 1000px) { .form-grid, .node-details { grid-template-columns: minmax(0, 440px); } }
@media (max-width: 700px) { .waybill-form-page { padding: 14px 10px 86px; }.page-heading { align-items: flex-start; flex-direction: column; }.form-section { padding: 16px 10px; }.node-address-item, .node-time-item { flex-basis: 100%; }.planning-row ::v-deep .el-select { width: min(280px, 100%); }.page-heading__actions { flex-wrap: wrap; } }
</style>
